import { SprintAPI } from '../../utils/api';
import { DYNAMO_ITEM_MAX_BYTES, estimateSprintItemBytes } from '../../utils/sprintItemSize';

function assertFitsDynamo(sprint) {
  if (estimateSprintItemBytes(sprint) < DYNAMO_ITEM_MAX_BYTES) return;
  const err = new Error('Failed to save sprint: Item size has exceeded the maximum allowed size');
  err.sprintName = sprint?.name;
  throw err;
}

/**
 * Persist a mission moving from one campaign to another without an empty gap.
 *
 * Write the sprint that GAINS the mission first. If that fails, the loser is
 * untouched on the server. If the loser write then fails, roll the gainer back
 * so the mission is not stranded in neither campaign.
 */
export async function persistMovedMissionPair({
  gainId,
  gainSprint,
  loseId,
  loseSprint,
  previousGainSprint,
}) {
  assertFitsDynamo(gainSprint);
  assertFitsDynamo(loseSprint);

  await SprintAPI.update(gainId, gainSprint);
  try {
    await SprintAPI.update(loseId, loseSprint);
  } catch (loseErr) {
    if (previousGainSprint) {
      try {
        await SprintAPI.update(gainId, previousGainSprint);
      } catch (rollbackErr) {
        console.error('[MOVE_MISSION] Failed to roll back gainer after loser save failed:', rollbackErr);
        loseErr.rollbackFailed = true;
      }
    }
    throw loseErr;
  }
}
